'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import tkns from '@lualtek/tokens/web/tokens.json';
import clsx from 'clsx';
import { domMax, LazyMotion, m, } from 'motion/react';
import { forwardRef, useId, useMemo } from 'react';
import { FocusOn } from 'react-focus-on';
import { Overlay, useResponsiveContext, } from '../../index.js';
import { ModalContent } from './content/modal-content.js';
import styles from './modal.module.css';
/**
 * @deprecated This component is outdated. Use `Sheet` instead.
 */
export const Modal = forwardRef(({ children, className, closeOnClickOutside = true, autoFocus = true, onClose, isOpen, index, onAnimationStart, onDragStart, onDragEnd, onDrag, ...otherProps }, forwardedRef) => {
    const headingId = useId();
    const { matches } = useResponsiveContext();
    const ModalAnimation = useMemo(() => ({
        visible: {
            scale: 1,
            opacity: 1,
            y: 0,
            transition: {
                easing: tkns.easing.entrance,
                duration: parseFloat((matches.small ? tkns.duration[100] : tkns.duration[300]).replace('s', '')),
            },
        },
        hidden: {
            scale: matches.small ? 0.98 : 1,
            opacity: matches.small ? 0 : 1,
            y: matches.small ? 0 : '100%',
            transition: {
                easing: tkns.easing.exit,
                duration: parseFloat(tkns.duration[100].replace('s', '')),
            },
        },
    }), [matches]);
    return (_jsx(Overlay, { onClose: onClose, index: index, children: isOpen
            && (_jsx(FocusOn, { onClickOutside: closeOnClickOutside ? onClose : undefined, onEscapeKey: onClose, autoFocus: autoFocus, children: _jsx(LazyMotion, { features: domMax, children: _jsx(m.div, { variants: ModalAnimation, initial: "hidden", animate: "visible", exit: "hidden", role: "dialog", "aria-modal": "true", "aria-labelledby": headingId, className: clsx(styles.Modal, className), ref: forwardedRef, ...otherProps, children: children }) }) })) }));
});
Modal.Content = ModalContent;
